import styled from 'styled-components';

export const LogoBox = styled.div`
  border: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
  height: 70px;
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SaleCyclePanel = styled.div`
  min-height: 110px;
`;
export const AddWrapper = styled.div`
  max-width: 120px;
`;
export const NewElement = styled.button`
  padding: 0px;
  margin: 0px;
  width: 50px;
  height: 50px;
  display: block;
  text-decoration: none;
  color: white;
  outline: none;
  border-radius: 10px;
  box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.16);
  background-color: ${({ theme }) => theme.vars.newColor.white};
  border: none;
  cursor: pointer;
`;
